// extracted by mini-css-extract-plugin
export var addToCartButton = "_gk-b";
export var arrowButtonContainer = "_gk-9";
export var arrowButtonIcon = "_gk-a";
export var carouselArrowButton = "_gk-6";
export var carouselElementContainer = "_gk-1";
export var left = "_gk-7";
export var productDisplayCarouselContainer = "_gk-0";
export var productTileContainer = "_gk-2";
export var productTileImage = "_gk-4";
export var productTileImageContainer = "_gk-3";
export var productTileTitle = "_gk-5";
export var right = "_gk-8";
export var sliderOverflow = "_gk-c";